import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Container,
  Paper,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import {
  PRIVACY_POLICY_SECTIONS,
  PRIVACY_POLICY_LAST_UPDATED,
} from "../../content/privacyPolicy";

export const PrivacyPolicyView: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: 3,
        bgcolor: "bg.main",
      }}
    >
      <Container maxWidth="md">
        <MuiLink
          component={Link}
          to="/login"
          sx={{ display: "inline-block", mb: 2 }}
        >
          ← Tillbaka till inloggning
        </MuiLink>
        <Typography variant="h4" component="h1" color="primary" gutterBottom>
          Villkor och integritetspolicy
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontStyle: "italic", mb: 3 }}
        >
          Senast uppdaterad: {PRIVACY_POLICY_LAST_UPDATED}
        </Typography>
        {PRIVACY_POLICY_SECTIONS.map((section) => (
          <Paper
            key={section.title}
            elevation={1}
            sx={{ p: 3, mb: 2, borderRadius: 2 }}
          >
            <Typography variant="h6" color="primary" gutterBottom>
              {section.title}
            </Typography>
            {section.subsections.map((sub, i) => (
              <Box key={i} sx={{ mt: sub.title ? 2 : 0 }}>
                {sub.title && (
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, mb: 0.5 }}
                  >
                    {sub.title}
                  </Typography>
                )}
                <Typography
                  variant="body2"
                  sx={{ whiteSpace: "pre-line", lineHeight: 1.7 }}
                >
                  {sub.body}
                </Typography>
              </Box>
            ))}
          </Paper>
        ))}
      </Container>
    </Box>
  );
};
